import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import FeaturesSection from '../../components/FeaturesSection/FeaturesSection';
import FunFact2 from '../../components/FunFact2/FunFact2';
import TeamSection from '../../components/TeamSection/TeamSection';
import SkillSection from '../../components/SkillSection/SkillSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.png';
import SkillImage from '../../images/skill.jpg';

const ServicePage = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header wpo-header-style-4'} Logo={Logo} />
            <PageTitle pageTitle={'Services'} pagesub={'Services'} />
            <ServiceSection hclass={"wpo-service-area section-padding"} ServiceBtn={true} />
            <FeaturesSection hclass={"wpo-features-area section-padding"} />
      
            <Footer hclass={'wpo-site-footer'} />
            <Scrollbar />
        </Fragment>
    )
};
export default ServicePage;
      